import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import baseURL from '../../config';

const ModifySubscription = () => {
  const { id } = useParams(); // vesselOwnerId
  const location = useLocation();

  // safely destructure with fallback
  const { subscriptionId, fetchvesselCount } = location.state || {};

  const [email, setEmail] = useState('');
  const [vesselCount, setVesselCount] = useState(fetchvesselCount || 1);
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate(); 

  // Fetch vessel owner details (to prefill email)
  useEffect(() => {
    const fetchVesselOwnerDetails = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${baseURL}/api/vesselDetails/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data.data;
        if (data?.email) setEmail(data.email);
      } catch (err) {
        setErrorMsg('Failed to fetch vessel owner details.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchVesselOwnerDetails();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subscriptionId) {
      return alert('Missing subscription ID');
    }

    try {
      setSubmitting(true);
      const token = localStorage.getItem('token');
      const payload = {
        subscriptionId,
        newVesselCount: Number(vesselCount),
        newBillingCycle: billingCycle,
      };

      const response = await axios.post(
        `${baseURL}/api/vesselowner-subscription/updateSubscription`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert('Subscription updated successfully');
      // console.log('Updated subscription:', response.data);
       navigate(-1);
    } catch (err) {
      console.error('Error updating subscription', err);
      alert(err.response?.data?.message || 'Failed to update subscription');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Paper elevation={6} sx={{ p: 4, borderRadius: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom align="center" color='red'>
        Upgrade Your Subscription
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={2}>
          <CircularProgress />
        </Box>
      ) : errorMsg ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          {errorMsg}
        </Alert>
      ) : (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <TextField
            fullWidth
            required
            type="email"
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            disabled
          />

          <TextField
            fullWidth
            required
            type="number"
            label="Number of Vessels"
            variant="outlined"
            margin="normal"
            inputProps={{ min: 1 }}
            value={vesselCount}
            onChange={(e) => setVesselCount(e.target.value)}
          />

          <TextField
            select
            fullWidth
            label="Billing Cycle"
            value={billingCycle}
            onChange={(e) => setBillingCycle(e.target.value)}
            margin="normal"
          >
            <MenuItem value="monthly">Monthly</MenuItem>
            <MenuItem value="yearly">Yearly</MenuItem>
          </TextField>
<Button
  type="submit"
  variant="contained"
  fullWidth
  disabled={submitting}
  sx={{
    mt: 2,
    color: "#fff",
    background: "linear-gradient(90deg, #6a1b9a 0%, #8e24aa 100%)",
    fontWeight: "bold",
    letterSpacing: 1,
    boxShadow: 3,
    transition: "0.3s",
    "&:hover": {
      background: "linear-gradient(90deg, #8e24aa 0%, #6a1b9a 100%)",
      boxShadow: 6,
      transform: "scale(1.03)",
    },
  }}
>
  {submitting ? 'Updating...' : 'Upgrade Plan'}
</Button>
        </Box>
      )}
    </Paper>
  );
};

export default ModifySubscription;
